import React, { useEffect, useRef, useState } from "react";
import { useTooltip } from "../../stores/useTooltip";

import styles from "./TooltipModal.module.scss";

type Props = {};

function TooltipModal({}: Props) {
  const tooltipInfo = useTooltip(state => state.tooltipInfo);
  const [didRender, setDidRender] = useState(false);
  const contentRef = useRef(null!);

  useEffect(() => {
    let index: number | null = null;

    if (tooltipInfo) {
      index = window.setTimeout(() => {
        setDidRender(true);
      }, 10);
    } else {
      setDidRender(false);
    }

    return () => {
      index && clearTimeout(index);
    };
  }, [tooltipInfo]);

  function getPosition() {
    if (tooltipInfo) {
      if (tooltipInfo.type === "bottom") {
        return {
          top: tooltipInfo.top! + 8,
          left: tooltipInfo.left,
          transform: didRender
            ? "scale(1) translateX(-50%)"
            : "scale(0.5) translateX(-50%)",
        };
      } else if (tooltipInfo.type === "right") {
        return {
          top: tooltipInfo.top,
          left: tooltipInfo.left! + 16,
          transform: didRender
            ? "scale(1) translateY(-50%)"
            : "scale(0.5) translateY(-50%)",
        };
      } else if (tooltipInfo.type === "top") {
        return {
          top: tooltipInfo.top! - 24,
          left: tooltipInfo.left,
          transform: didRender
            ? "scale(1) translate3d(-50%, -50%, 0)"
            : "scale(0.5) translate3d(-50%, -50%, 0)",
        };
      }
    }
  }

  return (
    <>
      {tooltipInfo ? (
        <div
          style={getPosition()}
          className={`${styles.tooltipContainer} ${
            tooltipInfo.bigFont ? styles.bigFont : ""
          } ${didRender ? styles.didRender : ""}`}
        >
          <div className={styles.content} ref={contentRef}>
            {tooltipInfo.tooltipText}
          </div>
        </div>
      ) : null}
    </>
  );
}

export default TooltipModal;
